<!--
 * @Description: 手动补发
 * @Author: gao shuai
 * @Date: 2020-07-03 11:21:45
 * @LastEditTime: 2020-07-29 09:10:50
 * @LastEditors: gao shuai
-->
<template>
  <div class="areaBox">
    <van-pull-refresh class="scrolldiv" v-model="refreshing" @refresh="onRefresh">
      <ul class="operBox">
        <li>
          <span class="tit">游戏分区：</span>
          <div class="input">
            <slector title="游戏分区" :columns="gameDivisiondrow" :value.sync="gameDivisionpage"></slector>
          </div>
        </li>
        <li>
          <span class="tit">充值方式：</span>
          <div class="input">
            <slector title="充值方式" :columns="rechargemodedrow" :value.sync="rechargemodepage"></slector>
          </div>
        </li>
        <li>
          <span class="tit">游戏账号：</span>
          <div class="input">
            <span class="inp">
              <input v-model="gameaccount">
            </span>
          </div>
        </li>
        <li>
          <span class="tit">充值金额：</span>
          <div class="input">
            <span class="inp">
              <input v-model="amountofrecharge" type="number">
            </span>
          </div>
        </li>
        <li>
          <span class="tit">额外补发：</span>
          <div class="input t_l">
            <span style="width:120px;display:inline-block;" class="inp">
              <input v-model="handextra" type="number">
            </span>
            <span class="txt">%</span>
          </div>
        </li>
      </ul>
      <div style="height:22px;background:#f5f5f5;"></div>
      <div class="checkedBox">
        <span class="listspan">
          <van-checkbox v-model="isGiveAmount" shape="square" checked-color="#1abc9c">包含赠送金额</van-checkbox>
        </span>
        <span class="listspan">
          <van-checkbox v-model="isRedPacketAmount" shape="square" checked-color="#1abc9c">包含红包赠送</van-checkbox>
        </span>
      </div>
      <p class="t_c mgt20">
        <van-button color="linear-gradient(to bottom, #3de9a9, #23cc9a)" @click="handleOrder"><span class="pdl30 pdr30">确定</span></van-button>
      </p>
      <van-list v-model="loading" :offset="80" :immediate-check="false" :finished="finished" finished-text="我是有底线的" @load="onLoad">
        <div class="tableBox">
          <div class="tableCont">
            <ul>
              <li>
                <span class="td1">时间</span>
                <span class="td2">分区</span>
                <span class="td3">账号</span>
                <span class="td4">金额</span>
              </li>
            </ul>
            <ul v-if="list.length>0" class="border-top">
              <li v-for="(item,i) in list" :key="'list'+i">
                <span class="td1">
                  <i class="blockI">{{item.reissueDate.split(' ')[0]}}</i>
                  <i class="blockI">{{item.reissueDate.split(' ')[1]}}</i>
                </span>
                <span class="td2 secondLine">{{item.partitionsName}}</span>
                <span class="td3 secondLine">{{item.playerAccount}}</span>
                <span class="td4">{{item.amount.toFixed(2)}}</span>
              </li>
            </ul>
            <div v-else class="nocontent">暂无内容</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import slector from '../components/slector1';
export default {
  components: {
    slector
  },
  data() {
    return {
      gameDivisiondrow: [], // 游戏分区下拉
      gameDivisionpage: '', // 游戏分区
      rechargemodepage: '', // 充值方式
      rechargemodedrow: [], // 充值方式下拉
      gameaccount: '', // 游戏账号
      amountofrecharge: '', // 充值金额
      handextra: '', // 额外补发
      isGiveAmount: false, // 不含赠送金额
      isRedPacketAmount: false, // 包含红包赠送
      list: [], // 列表
      loading: false,
      finished: false,
      refreshing: false,
      PageNumber: 1,
      PageSize: 20,
      total: 0
    };
  },
  methods: {
    // 游戏分区下拉
    gameareaDrow() {
      this.$api.home
        .gamelist()
        .then((data) => {
          if (data.status === 200) {
            this.gameDivisiondrow = data.data.map((item) => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 充值方式下拉
    gamepayDrow() {
      this.$api.home
        .payDrow()
        .then((data) => {
          if (data.status === 200) {
            this.rechargemodedrow = data.data.map((item) => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 手动补单
    handleOrder() {
      if (this.gameDivisionpage === '') {
        this.$toast('请选择游戏分区！');
        return;
      } else if (this.rechargemodepage === '') {
        this.$toast('请选择充值方式！');
        return;
      } else if (this.gameaccount === '') {
        this.$toast('请输入游戏帐号！');
        return;
      } else if (this.amountofrecharge === '') {
        this.$toast('请输入充值金额！');
        return;
      } else if (this.handextra.toString().indexOf('.') > -1) {
        this.$toast('额外补发必须为整数！');
        return;
      }
      this.$api.home
        .handOrder({
          partitionId: this.gameDivisionpage,
          productId: this.rechargemodepage,
          playerAccount: this.gameaccount,
          payAmount: parseFloat(this.amountofrecharge),
          Extra: this.handextra === '' ? 0 : parseInt(this.handextra),
          isGiveAmount: this.isGiveAmount,
          isRedPacketAmount: this.isRedPacketAmount
        })
        .then((data) => {
          if (data.status === 200) {
            this.gameDivisionpage = '';
            this.rechargemodepage = '';
            this.gameaccount = '';
            this.amountofrecharge = '';
            this.isGiveAmount = false;
            this.isRedPacketAmount = false;
            this.handextra = '';
            this.$toast.success('补发成功');
            if (this.$route.query.id) {
              this.$router.replace({ path: '/partitionManage' });
            } else {
              this.loading = false;
              this.finished = false;
              this.refreshing = false;
              this.PageNumber = 1;
              this.list = [];
              this.getlist();
            }
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 补发列表
    getlist() {
      this.$api.home
        .allOrderList({
          Type: 1,
          PlayerAccount: '',
          PartitionId: 0,
          PartitionName: '',
          PageNumber: this.PageNumber,
          PageSize: this.PageSize
        })
        .then((data) => {
          if (data.status === 200) {
            if (this.PageNumber === 1) {
              this.list = data.data;
            } else {
              this.list = this.list.concat(data.data);
            }
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
            if (this.list.length >= this.total) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
              this.PageNumber++;
            }
            this.refreshing = false;
          } else {
            this.list = [];
            this.refreshing = false;
            this.finished = false;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 下拉刷新
    onRefresh() {
      this.PageNumber = 1;
      this.finished = false;
      this.getlist();
    },
    // 上拉加载
    onLoad() {
      if (this.finished) {
        return;
      }
      this.getlist();
    }
  },
  created() {
    this.gameareaDrow();
    this.gamepayDrow();
    this.getlist();
    if (this.$route.query.id) {
      this.gameDivisionpage = this.$route.query.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.areaBox {
  height: 100%;
  overflow-y: auto;
  &::v-deep .van-checkbox {
    .van-checkbox__label {
      color: #666;
    }
    .van-checkbox__icon {
      .van-icon {
        border-radius: 4px;
      }
    }
  }
  .operBox {
    padding-top: 50px;
    li {
      margin-bottom: 23px;
      text-align: center;
      .tit {
        display: inline-block;
        vertical-align: middle;
        font-size: 17px;
        color: #666;
      }
      .input {
        display: inline-block;
        vertical-align: middle;
        width: 220px;
        .txt {
          color: #666;
          font-size: 16px;
          vertical-align: middle;
        }
      }
      &:last-child {
        margin-bottom: 10px;
      }
    }
  }
  .checkedBox {
    padding-left: 35px;
    font-size: 13px;
    margin-top: 15px;
    .listspan {
      display: inline-block;
      vertical-align: middle;
      margin-right: 40px;
      margin-bottom: 15px;
    }
  }
  .inp {
    display: block;
    margin-right: 10px;
    background: #fff;
    border-radius: 4px;
    color: #b1b1b1;
    font-size: 14px;
    input {
      display: block;
      border: none;
      outline: none;
      width: 100px;
      height: 30px;
      padding: 0 10px;
      width: 100%;
      border-radius: 4px;
      border: 1px solid #dbd8d8;
      &:focus {
        border-color: #1abc9c;
      }
      // &::placeholder {
      //   color: #1abc9c;
      // }
    }
  }
  .tableBox {
    margin-top: 20px;
    padding: 0 10px;
    .tableCont {
      border: 1px solid #c6c6c6;
      .nocontent {
        border-top: 1px solid #c6c6c6;
        text-align: center;
        font-size: 14px;
        height: 60px;
        line-height: 60px;
        color: #666;
        background: #eee;
      }
      .border-top {
        border-top: 1px solid #c6c6c6;
        li {
          &:nth-child(ODD) {
            background: #dce8fe;
          }
        }
      }
      li {
        display: flex;
        flex-flow: row nowrap;
        &:last-child {
          span {
            border-bottom: none;
          }
        }
        span {
          padding: 0 5px;
          height: 38px;
          line-height: 38px;
          font-size: 13px;
          color: #262626;
          text-align: center;
          // font-weight: bold;
          border-right: 1px solid #c6c6c6;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          word-break: break-all;
          border-bottom: 1px solid #c6c6c6;
          .blockI {
            display: block;
            height: 16px;
            line-height: 22px;
          }
          &.td1 {
            width: 23%;
          }
          &.td2 {
            width: 30%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            &.secondLine {
              line-height: 18px;
            }
          }
          &.td3 {
            width: 27%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            &.secondLine {
              line-height: 18px;
            }
          }
          &.td4 {
            width: 20%;
            border-right: none;
          }
        }
      }
    }
  }
}
</style>
